import Axios from './base';

export const GetInvoices = (params = {}) => {
    console.log('GetInvoices called with params:', params);
    const queryString = new URLSearchParams(params).toString();
    console.log('Query string built:', queryString);
    const url = `Invoices${queryString ? `?${queryString}` : ''}`;
    console.log('Final URL:', url);
    return Axios().get(url);
}
export const GetInvoiceById = (id) => Axios().get('Invoices/' + id)
export const UpdateLineItem = (id, entity) => Axios().post('Invoices/LineItems/' + id, entity)
export const AddLineItem = (id, entity) => Axios('Added Successfully').post('Invoices/LineItems/Add/' + id, entity)
export const RemoveLineItem = (id, uid) => Axios().delete('Invoices/LineItems/' + id + '/' + uid)
export const PayLineItem = (id, entity) => Axios().put('Invoices/LineItems/' + id, entity)
export const SearchInvoicePublic = (invoiceNumber) => Axios().get('Invoices/Public/Search/' + invoiceNumber)
export const PayInvoicePublic = (id, entity) => Axios().put('Invoices/Public/Pay/' + id, entity)
export const DownloadInvoicePdfPublic = (id) => Axios(null, null, { responseType: 'blob' }).get('Invoices/Public/Pdf/' + id)
export const EmailInvoicePdfPublic = (id, entity) => Axios('Invoice Sent').post('Invoices/Public/EmailPdf/' + id, entity)
export const CancelInvoice = (id) => Axios().put('Invoices/Cancel/' + id)

export const GetReceipts = (entity) => Axios().post('Invoices/Receipts', entity)

export const CreateWaitlistInvoice = (receipt, waitlist) => Axios('Added to WaitList').post('Invoices/WaitList', {
    receipt, waitlist
})

export const AddRemark = (id, doc) => Axios().get('Invoices/Remarks/Add/' + id + '/' + doc)
export const SendInvoiceCopy = (entity) => Axios('Invoice Sent').post('SendInvoiceCopy', entity)
export const EmailInvoicePdf = (id, entity) => Axios('Invoice Sent').post('Invoices/EmailPdf/' + id, entity)
export const DownloadInvoicePdf = (id) => Axios(null, null, { responseType: 'blob' }).get('Invoices/Pdf/' + id)

export const CreateTieDown = (id, entity) => {
    if (id)
        return Axios().post('Invoices/TieDown/' + id, entity)
    return Axios().post('Invoices/TieDown', entity)
}

export const GetCompany = (user) => Axios().post('Invoices/User/Details', user)
export const GetTieDowns = (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = `Invoices/List/TieDowns${queryString ? `?${queryString}` : ''}`;
    return Axios().get(url);
}


export const AddInvoice = (entity) => Axios('Created Invoice Successfully').post('Invoices', entity)
export const UpdateInvoiceLateFee = (id, lateFeeData) => Axios('Saved').put('Invoices/Sku/' + id, lateFeeData)

export const UpdateComments = (id, entity) => Axios('Added Successfully').post('Invoices/Comments/' + id, entity)